import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { fetch } from 'Utils';
import { queryKey } from 'Constants';
import { DataQueryParams, MarketingAssetConfig } from 'Types';

const config = (options = {}) => {
	return {
		...options,
		keepPreviousData: false
	};
};

export const useMarketingTemplate = <T = MarketingAssetConfig[]>(
	{ toolType, useFor }: DataQueryParams,
	options?: UseQueryOptions<T, any, MarketingAssetConfig[]>
): UseQueryResult<MarketingAssetConfig[], unknown> => {
	return useQuery(
		{
			queryKey: [queryKey.marketingTemplates, { toolType, useFor }],
			queryFn: () => fetch.marketingTemplates(toolType, useFor),
			...config(options)
		}
	);
};
